import type { CommonRequestFn } from "@marketplace/http";

import { ENDPOINTS } from "@/constants/endpoints";
import { httpClient } from "@/http";
import type {
  GenerateRandomCodeRequestDto,
  GenerateRandomCodeResponseDto
} from "@/types";

type GeneratorServiceContract = {
  generateRandomCode: CommonRequestFn<
    GenerateRandomCodeRequestDto,
    GenerateRandomCodeResponseDto
  >;
};

export const GeneratorService: GeneratorServiceContract = {
  generateRandomCode: ({ payload, options }) => {
    return httpClient
      .get(ENDPOINTS.GENERATOR.RANDOM_CODE, {
        ...options,
        searchParams: payload
      })
      .json<GenerateRandomCodeResponseDto>();
  }
};
